import type { FC, ReactNode } from 'react';

import Button from 'components/_core/Button';
import * as Form from 'components/_core/form';
import SunshineDropdown from 'components/_core/SunshineDropdown';

import { usePaymentCardsListState } from '../PaymentCardsListFiltersProvider';
import { State } from '../PaymentCardsListFiltersProvider/reducer';

type AvailableFilters = keyof State['filters'];

type Item = {
  label: string;
  value: string;
};

interface Props {
  children: ReactNode;
  name: AvailableFilters;
  items: Item[];
}

export const BadgeFilter: FC<Props> = ({ children, items, name }) => {
  const { dispatch, filters } = usePaymentCardsListState();

  const handleOnItemClick = (filter: AvailableFilters, value: string) => {
    switch (filter) {
      case 'cardProductType':
        dispatch({ payload: value, type: 'UPDATE_CARD_PRODUCT_TYPE_FILTER' });
        break;
      case 'owner':
        dispatch({ payload: value, type: 'UPDATE_OWNER_FILTER' });
        break;
      case 'status':
        dispatch({
          payload: value,
          type: 'UPDATE_STATUS_FILTER',
        });
        break;
    }
  };

  const selectedFilters = filters[name].length;

  return (
    <SunshineDropdown closeOnSelect={false}>
      <SunshineDropdown.Trigger>
        <Button
          icon="chevron-down"
          iconPosition="right"
          size="sm"
          variant="discreet"
        >
          {children} {selectedFilters ? `(${selectedFilters})` : ''}
        </Button>
      </SunshineDropdown.Trigger>

      <SunshineDropdown.List>
        {items.map((item) => (
          <SunshineDropdown.Item
            key={item.value}
            onClick={() => handleOnItemClick(name, item.value)}
          >
            <Form.Checkbox
              isChecked={filters[name].includes(item.value)}
              pointerEvents="none"
            >
              <Form.Checkbox.Label>{item.label}</Form.Checkbox.Label>
            </Form.Checkbox>
          </SunshineDropdown.Item>
        ))}
      </SunshineDropdown.List>
    </SunshineDropdown>
  );
};
